'use strict';

exports.__esModule = true;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _memoize = require('./memoize');

var _memoize2 = _interopRequireDefault(_memoize);

exports['default'] = _memoize2['default'];
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/lru-memoize/lib/index.js
 ** module id = 53
 ** module chunks = 0
 **/